import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/tracking.scss";

const Tracking = () => {
  const { orderId } = useParams();

  const mockTracking = {
    orderId: orderId || "ORD20240513001",
    trackingNumber: "SF1234567890",
    carrier: "Express Delivery",
    estimatedDelivery: "2024-05-18",
    currentStatus: "In Transit",
    events: [
      {
        time: "2024-05-15 14:30",
        title: "Package in transit",
        location: "Distribution Center - Milan Hub",
        description: "Package has left the distribution center and is on its way to the destination",
        completed: true,
      },
      {
        time: "2024-05-14 22:15",
        title: "Arrived at distribution center",
        location: "Distribution Center - Rome",
        description: "Package has arrived at the local distribution center",
        completed: true,
      },
      {
        time: "2024-05-14 09:45",
        title: "Departed from warehouse",
        location: "Warehouse - Florence",
        description: "Package has been dispatched from the seller warehouse",
        completed: true,
      },
      {
        time: "2024-05-13 18:30",
        title: "Order processed",
        location: "Warehouse - Florence",
        description: "Seller has processed the order and prepared for shipment",
        completed: true,
      },
      {
        time: "2024-05-13 15:00",
        title: "Order confirmed",
        location: "Online",
        description: "Order has been confirmed and payment received",
        completed: true,
      },
    ],
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="tracking-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="tracking-page__main">
        <div className="tracking-container">
          <div className="tracking-header">
            <Link to="/orders" className="back-link" onClick={toTop}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
              Back to Orders
            </Link>
            <h1 className="tracking-title">Track Package</h1>
          </div>

          <div className="tracking-info-card">
            <div className="tracking-info-row">
              <div className="info-item">
                <span className="info-label">Order Number</span>
                <span className="info-value">{mockTracking.orderId}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Tracking Number</span>
                <span className="info-value tracking-number">{mockTracking.trackingNumber}</span>
              </div>
            </div>
            <div className="tracking-info-row">
              <div className="info-item">
                <span className="info-label">Carrier</span>
                <span className="info-value">{mockTracking.carrier}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Estimated Delivery</span>
                <span className="info-value estimated">{mockTracking.estimatedDelivery}</span>
              </div>
            </div>
          </div>

          <div className="tracking-status-banner">
            <div className="status-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="32" height="32">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
              </svg>
            </div>
            <div className="status-text">
              <h2>{mockTracking.currentStatus}</h2>
              <p>Your package is on its way</p>
            </div>
          </div>

          <div className="tracking-timeline">
            <h2 className="timeline-title">Shipment Progress</h2>
            <div className="timeline">
              {mockTracking.events.map((event, index) => (
                <div
                  key={index}
                  className={`timeline-item ${event.completed ? "is-completed" : ""}`}
                >
                  <div className="timeline-marker">
                    <div className="marker-dot">
                      {event.completed && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" width="12" height="12">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>
                      )}
                    </div>
                    {index < mockTracking.events.length - 1 && <div className="marker-line" />}
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-header">
                      <h3 className="timeline-heading">{event.title}</h3>
                      <span className="timeline-time">{event.time}</span>
                    </div>
                    <p className="timeline-location">{event.location}</p>
                    <p className="timeline-description">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="tracking-help">
            <p>Need help with your delivery?</p>
            <Link to="/contact" className="help-link" onClick={toTop}>
              Contact Support
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Tracking;
